import { Component, OnInit, Renderer2, HostListener } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { TCCPCommonService } from '../../services/tccp-common.service';
import { TCCPLocalStorageService } from '../../services/tccp-local-storage.service';
import { environment } from '../../../../environments/environment';
import { LoaderService } from '../../loader/loader.service';
import { Gtag } from 'angular-gtag';
import { MatDialog } from '@angular/material/dialog';
import { TCCPConstantValues } from '../../../shared/models/tccp-constants';
import { Content } from '../../../shared/models/content';
import { VideoPlayerDialogComponent } from '../video-player-dialog/video-player-dialog.component';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-home-header',
  templateUrl: './home-header.component.html',
  styleUrls: ['./home-header.component.scss']
})

export class HomeHeaderComponent implements OnInit {
  public envName = '';
  public routerPath = '';
  public hasFocus = false;
  public appName = environment.applicationName;
  public isInternal = false;
  public windowWidth = window.innerWidth;
  public showError = false;
  public featureType: string = null;
  public resultLink = '';
  public logoPath = '';
  public hasVideo = false;
  public hasResource = false;
  public hasMessageGuide = false;
  public isExpanded = false;
  public isResourcePanelOpened = false;
  public isVideoPanelOpened = false;
  public resources = {};
  public videos = {};
  public config = {};
  public hideSelectionSection = false;
  public showResources = false;
  public showErrorGuide = false;
  public resourceDetails = [];
  public videoDetails = [];
  public isMenuOpen = false;
  public ctpAdminPortalUrl: string = TCCPConstantValues[environment.applicationName].Urls['CTP_ADMIN_PORTAL'];
  public content: Content[];
  public videoContent: Content[];
  public Group: string[];
  public videoGroup: string[];
  public hideVideos = true;
  public hideResources = true;
  public hideMenu = false;
  readonly homeURL = this.storageService.getFeatureType() === 'internal' ? `${this.appName}/home/internal` :
    `${this.appName}/home`;

  constructor(
    private router: Router, private fb: FormBuilder,
    public commonService: TCCPCommonService,
    private storageService: TCCPLocalStorageService,
    private loaderService: LoaderService, private activeRoute: ActivatedRoute,
    public authService: MsalService,
    private gtag: Gtag, private renderer: Renderer2, private dialog: MatDialog) {
    this.commonService.hideModelYearSection.emit(false);
    this.commonService.showMessageGuide.subscribe(data => {

      this.showErrorGuide = false;
      this.goBackToHomeFromMessageGuide();
    });

    this.commonService.hideHeaderMenus.subscribe(data => {
      if (data) {
        this.isVideoPanelOpened = false;
        this.isResourcePanelOpened = false;
        const videoSection = document.querySelector('.resource-container.videos');
        const documentSection = document.querySelector('.resource-container.documents');
        if (videoSection) {
          this.collapseSection(videoSection);
        }
        if (documentSection) {
          this.collapseSection(documentSection);
        }
      }
    });

    this.commonService.hideModelYearSection.emit(false);
  }

  toggleResourceMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  focus() {
    this.hasFocus = true;
  }

  @HostListener('window: popstate', ['$event'])
  onPopState(event: Event): void {
    event.preventDefault();
    this.commonService.hideModelYearSection.emit(false);
  }

  ngOnInit() {
    this.routerPath = `${this.appName}/home`;
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.hideSelectionSection = false;
    this.commonService.hideModelYearSection.emit(false);
    this.commonService.hideModelYearSection.subscribe(flag => {
      this.hideSelectionSection = flag;
    });
    this.featureType = this.router.url.includes('internal') ? 'internal' : '';
    this.logoPath = this.featureType === 'internal' ? `${this.appName}/home/internal` : `${this.appName}/home`;
    this.isInternal = this.featureType === 'internal';
    if (this.isInternal) {
      this.getAllVideos();
      this.getAllResources();
      this.getAllErrorGuides();
    }
    const envName = window.location.href;
    if (envName.includes(TCCPConstantValues.base.url_contexts.TOYOTA_QUICKGUIDE)) {
      this.envName = TCCPConstantValues.base.url_contexts.TOYOTA_QUICKGUIDE;
      this.hideMenu = true;
    }
    if (envName.includes('lexusguide')) {
      this.envName = 'lexusguide';
      this.hideMenu = true;
    }
    if (environment.applicationName === 'toyotaguide' || environment.applicationName === 'lexusguide') {
      this.appName = environment.applicationName;
      environment.applicationName = environment.applicationName === 'toyotaguide' ? 'toyota' :
        environment.applicationName === 'lexusguide' ? 'lexus' : environment.applicationName;
      this.appName = environment.applicationName === 'toyotaguide' ? 'toyota' :
        environment.applicationName === 'lexusguide' ? 'lexus' : environment.applicationName;
    }

    this.commonService.enableFeedback = false;
    this.storageService.setMPCCode(null);
    this.commonService.showFeedback.emit({ showFeedback: false });
    environment.applicationName = this.appName;
    this.storageService.setHome(this.homeURL);
    this.commonService.setGTagPageDetails('Home', `${this.appName}/home`, window.location.href);
    this.isInternal = false;
    this.storageService.setHome(this.homeURL); // change
    this.isInternal = this.commonService.setAppFeatureType(this.router.url);
    this.commonService.landingPage = true;
    this.storageService.clearFlow();
    this.loaderService.show();
  }

  onElasticSearch() {
    this.isMenuOpen = false;
    this.commonService.hideModelYearSection.emit(true);
    this.commonService.hideHeaderMenus.emit(true);
    this.router.navigate([`${this.appName}/search-page`]);
  }

  async getVehicle(vin) {
    return await this.commonService.getVehicleInfo(vin);
  }

  ngAfterViewChecked() {
    this.commonService.landingPage = true;
    const elResource = document.querySelector('.resource-block');
    const elVideo = document.querySelector('.resource-video-block');
    const el = document.querySelector('.responsive-content');
    if (!this.hideResources || !this.hideVideos) {
      if (elResource || elVideo) {
        const height = elResource && elVideo ? elResource.scrollHeight + elVideo.scrollHeight :
          !elResource ? elVideo.scrollHeight : elResource.scrollHeight;
        this.renderer.setStyle(el, 'height', height + 500 + 'px');
        console.log('from ngAfterViewChecked', height + 500 + 'px');
      }
    }
  }

  getTooltipContent() {
    return this.appName === 'toyota' ? 'toyota-vinToolTip' : 'lexus-vinToolTip';
  }

  goBackToHomeFromMessageGuide() {
    this.showErrorGuide = false;
    this.commonService.isMessageComponentOpened = false;
    this.commonService.hideBreadrumb.emit(false);
    window.history.back();
  }

  getAllVideos() {
    this.featureType = this.isInternal ? 'internal' : 'external';
    this.commonService.getAllVideos(this.featureType).subscribe(data => {
      if (data) {
        this.videoGroup = data.map(x => x.videos.videoGroup);
        this.videoGroup = this.videoGroup.filter((n, i) => this.videoGroup.indexOf(n) === i).sort((a, b) => a > b ? 1 : -1);
        this.hasVideo = this.videoGroup === null ? false : (this.videoGroup.length > 0 ? true : false);
        this.videoContent = data.sort((a, b) => a.videos.videoName > b.videos.videoName ? 1 : -1);
        this.videoDetails.push({ type: 'videos', count: this.videoContent.length });
      }
    });
  }

  getAllErrorGuides() {
    this.commonService.getAllErrorMessages().subscribe((response: any) => {
      if (response) {
        const formattedJSON = JSON.parse(response);
        this.hasMessageGuide = formattedJSON && formattedJSON.length > 0;
        console.log('this.hasMessageGuide', formattedJSON);
      }
    });
  }

  getAllResources() {
    this.featureType = this.isInternal ? 'internal' : 'external';
    this.commonService.getAllResources(this.featureType).subscribe(data => {
      if (data && data.length > 0) {
        this.showResources = true;
        let group = data.map(x => x.resources.resourceGroup);
        group = group.filter((n, i) => group.indexOf(n) === i).sort((a, b) => a > b ? 1 : -1);
        this.hasResource = group.length > 0;
        this.Group = data.map(x => x.resources.resourceGroup);
        this.Group = this.Group.filter((n, i) => this.Group.indexOf(n) === i).sort((a, b) => a > b ? 1 : -1);
        this.content = data.sort((a, b) => a.resources.resourceName > b.resources.resourceName ? 1 : -1);
        this.resourceDetails.push({ type: 'resources', count: this.content.length });
      }
    });
  }

  onLogout() {
    const env = window.location.host.split('.')[0];
    let externalUrl;
    console.log('ENV is : '+ env);
    if(env === 'dev' || env === 'qa'){
      externalUrl = this.appName === 'toyota' ? `${env}.${TCCPConstantValues.base.url_contexts.TOYOTA_EXTERNAL}.com` : `${env}.${TCCPConstantValues.base.url_contexts.LEXUS_EXTERNAL}.com`;
    }else{
      externalUrl = this.appName === 'toyota' ? `${TCCPConstantValues.base.url_contexts.TOYOTA_EXTERNAL}.com` : `${TCCPConstantValues.base.url_contexts.LEXUS_EXTERNAL}.com`;
    }
    this.storageService.setToken('');
    const externalLink = `${environment.protocol}//${externalUrl}/${this.appName}/home`
    console.log('external Link : '+ externalLink);
    this.authService.logoutRedirect({postLogoutRedirectUri: `${environment.protocol}//${externalUrl}/${this.appName}/home`});
  }

  toggleState() {
    this.isExpanded = !this.isExpanded;
  }

  public onLogoClick() {
    this.storageService.clearStorage();
  }

  public onMenuClick() {
    this.storageService.clearStorage();
  }

  onResourcesClick(e?) {
    this.isResourcePanelOpened = !this.isResourcePanelOpened;
    this.commonService.isResourceComponentOpened = this.isResourcePanelOpened;
    if (this.isResourcePanelOpened) {
      this.isVideoPanelOpened = false;
    }
    const section = document.querySelector('.resource-container.documents');
    if (!section) {
      return;
    }
    const isCollapsed = section.getAttribute('data-collapsed') === 'true';
    if (isCollapsed) {
      this.expandSection(section);
      this.isVideoPanelOpened = false;
      this.collapseSection(document.querySelector('.resource-container.videos'));
      section.setAttribute('data-collapsed', 'false ');
    } else {
      this.collapseSection(section);
    }
  }

  onVideosClick(e) {
    if (e) {
      e.preventDefault();
    }
    e.stopPropagation();
    this.isVideoPanelOpened = !this.isVideoPanelOpened;
    this.commonService.isVideosComponentOpened = this.isVideoPanelOpened;
    if (this.isVideoPanelOpened) {
      this.isResourcePanelOpened = false;
      if (this.showErrorGuide) {
        this.showErrorGuide = false;
        this.goBackToHomeFromMessageGuide();
      }
    }
    const section = document.querySelector('.resource-container.videos');
    if (!section) {
      return;
    }
    const isCollapsed = section.getAttribute('data-collapsed') === 'true';
    if (isCollapsed) {
      this.expandSection(section);
      this.isResourcePanelOpened = false;
      this.collapseSection(document.querySelector('.resource-container.documents'));
      section.setAttribute('data-collapsed', 'false ');
    } else {
      this.collapseSection(section);
    }
  }

  collapseSection(element) {
    if (element) {
      const sectionHeight = element.scrollHeight;
      const elementTransition = element.style.transition;
      element.style.transition = '';

      requestAnimationFrame(() => {
        element.style.height = `${sectionHeight}px`;
        element.style.transition = elementTransition;

        requestAnimationFrame(() => {
          element.style.height = `${0}px`;
        });
      });

      element.setAttribute('data-collapsed', 'true');
    }
  }

  expandSection(element) {
    const sectionHeight = element.scrollHeight;
    element.style.height = `${sectionHeight}px`;
    console.log('sectionHeight', sectionHeight);
    function addListner(e) {
      element.removeEventListener('transitionend', addListner);
      element.style.height = null;
    }
    element.addEventListener('transitionend', addListner);
    element.setAttribute('data-collapsed', 'false ');

  }

  public onServiceStatusClick(event?) {
    this.isVideoPanelOpened = false;
    this.showErrorGuide = false;
    this.isResourcePanelOpened = false;
  }

  public onErrorGuideClick(event) {
    event.stopPropagation();
    this.showErrorGuide = !this.showErrorGuide;
    if (this.showErrorGuide && this.windowWidth <= 768) {
      this.isExpanded = false;
    }
    const videoSection = document.querySelector('.resource-container.videos');
    const documentSection = document.querySelector('.resource-container.documents');
    if (videoSection) {
      this.collapseSection(videoSection);
    }
    if (documentSection) {
      this.collapseSection(documentSection);
    }
    if (this.showErrorGuide) {
      this.isVideoPanelOpened = false;
      this.isResourcePanelOpened = false;
      this.isMenuOpen = false;
      this.commonService.hideBreadrumb.emit(true);
      this.router.navigate([`${this.appName}/error-guides`]);
    } else {
      this.goBackToHomeFromMessageGuide();
      this.commonService.isMessageComponentOpened = false;
    }
  }


  displayCounter(event) {
    console.log('displayCounter', event);
  }

  openFileInNewTab(e, url) {
    if (e) {
      e.preventDefault();
    }
    e.stopPropagation();
    if (url) {
      window.open(url, '_blank');
    }
  }

  calculateDateDiff(uploadedDate) {
    let datediff = 0;
    const currentDate = new Date(new Date().toUTCString());
    const uploadDate = new Date(uploadedDate);
    datediff = Math.floor((Date.UTC(currentDate.getFullYear(), currentDate.getMonth(),
      currentDate.getDate()) - Date.UTC(uploadDate.getFullYear(), uploadDate.getMonth(), uploadDate.getDate())) / (1000 * 60 * 60 * 24));

    if (datediff < 30) {
      return true;
    }
    return false;
  }

  openDialog(url: string) {
    this.isMenuOpen = this.windowWidth <= 1024 ? this.isMenuOpen : false;
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    const match = url.match(regExp);
    const videoId = (match && match[7].length === 11) ? match[7] : false;
    const name: Content = this.videoContent.find(x => x['videos']['videoUrl'] === url);
    const videoName = name['videos']['videoName'];
    const videoDialog = this.dialog.open(VideoPlayerDialogComponent,
      { data: { videoUrl: videoId, name: videoName }, panelClass: 'icon-outside' });
    videoDialog.afterClosed().subscribe(() => this.closeDialog());
  }

  closeDialog() {
    const objDiv = document.querySelector('.overlay');
    objDiv.scrollTop = objDiv.scrollHeight;
    window.scroll(0, 0);
  }

  public toggleExpandedDisplay(sectionsToDisplay: string) {
    if (sectionsToDisplay === 'resourceDetails') {
      this.hideResources = !this.hideResources;
    } else {
      this.hideVideos = !this.hideVideos;
    }
  }
}
